import { toast } from "react-toastify";
import { ChevronDown } from "lucide-react";

const ReviewerSelect = ({
    reviewers = [],
    value = "",               // <- controlled value (email)
    onReviewerChange,
}) => {
    const handleChange = (e) => {
        const email = e.target.value ?? "";
        const reviewer = reviewers.find((r) => r.email === email) ?? null;

        if (reviewer) toast.info(`Reviewer set to ${reviewer.username}`);

        onReviewerChange?.(reviewer);
    };

    return (
        <div className="mt-4">
            <div className="relative mt-1">
                <select
                    id="reviewer"
                    name="reviewer"
                    value={value}
                    onChange={handleChange}
                    className="block w-full appearance-none rounded-md border border-slate-300 bg-white py-2 pl-3 pr-10 text-sm text-center shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                    aria-label="Select reviewer"
                >
                    <option value="">--- No reviewer selected ---</option>

                    {reviewers.map(({ email, username }) => (
                        <option key={email} value={email}>
                            {username} - {email}
                        </option>
                    ))}
                </select>

                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                    <ChevronDown className="h-4 w-4 text-slate-400" />
                </div>
            </div>

            <p className="mt-1 text-xs text-slate-500">
                Pick a reviewer to route this item for approval.
            </p>
        </div>
    );
};

export default ReviewerSelect;
